var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPopupEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 43L50 15L86 43V87H14V43Z",
    fill: "#244469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 73L14 43V87H86V43L50 73Z",
    fill: "#4571B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87L38 63L50 73L62 63L86 87H14Z",
    fill: "#5589D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1742 25.1913L28.3569 21.0078L25.5879 52.6574L49.9996 73.0005L73.7209 53.2327L76.1742 25.1913Z",
    fill: "#A1B6D6",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 23H26V53L50 73L74 53V23Z",
    fill: "#F8F9FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 49,
    width: 32,
    height: 1,
    rx: 0.5,
    fill: "#244469"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 53,
    width: 24,
    height: 1,
    rx: 0.5,
    fill: "#244469"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0881 35.574C57.0881 36.126 57.0221 36.666 56.8901 37.194C56.7581 37.722 56.5601 38.202 56.2961 38.634C56.0441 39.066 55.7201 39.414 55.3241 39.678C54.9281 39.93 54.4601 40.056 53.9201 40.056C53.4041 40.056 52.9841 39.918 52.6601 39.642C52.3361 39.354 52.1321 39.012 52.0481 38.616H51.9401C51.7121 39.012 51.3881 39.354 50.9681 39.642C50.5601 39.918 50.0501 40.056 49.4381 40.056C48.4781 40.056 47.7341 39.75 47.2061 39.138C46.6901 38.514 46.4321 37.692 46.4321 36.672C46.4321 35.88 46.5881 35.178 46.9001 34.566C47.2241 33.954 47.6801 33.474 48.2681 33.126C48.8681 32.778 49.5701 32.604 50.3741 32.604C50.9141 32.604 51.4481 32.652 51.9761 32.748C52.5161 32.832 52.9421 32.934 53.2541 33.054L53.0741 36.708C53.0621 36.9 53.0561 37.05 53.0561 37.158C53.0561 37.254 53.0561 37.32 53.0561 37.356C53.0561 37.944 53.1521 38.334 53.3441 38.526C53.5481 38.706 53.7761 38.796 54.0281 38.796C54.3761 38.796 54.6641 38.652 54.8921 38.364C55.1321 38.064 55.3121 37.668 55.4321 37.176C55.5641 36.684 55.6301 36.144 55.6301 35.556C55.6301 34.476 55.4081 33.558 54.9641 32.802C54.5321 32.046 53.9321 31.47 53.1641 31.074C52.4081 30.678 51.5441 30.48 50.5721 30.48C49.2401 30.48 48.1121 30.756 47.1881 31.308C46.2761 31.86 45.5801 32.616 45.1001 33.576C44.6321 34.536 44.3981 35.64 44.3981 36.888C44.3981 38.616 44.8541 39.942 45.7661 40.866C46.6901 41.79 48.0161 42.252 49.7441 42.252C50.4641 42.252 51.1661 42.168 51.8501 42C52.5461 41.844 53.1701 41.664 53.7221 41.46V42.828C53.1941 43.044 52.5941 43.224 51.9221 43.368C51.2621 43.512 50.5421 43.584 49.7621 43.584C48.3221 43.584 47.0921 43.32 46.0721 42.792C45.0521 42.264 44.2721 41.508 43.7321 40.524C43.1921 39.528 42.9221 38.334 42.9221 36.942C42.9221 35.826 43.0961 34.794 43.4441 33.846C43.7921 32.898 44.2961 32.076 44.9561 31.38C45.6281 30.672 46.4321 30.126 47.3681 29.742C48.3161 29.346 49.3841 29.148 50.5721 29.148C51.8321 29.148 52.9481 29.406 53.9201 29.922C54.9041 30.438 55.6781 31.176 56.2421 32.136C56.8061 33.096 57.0881 34.242 57.0881 35.574ZM48.0161 36.708C48.0161 37.44 48.1601 37.974 48.4481 38.31C48.7481 38.634 49.1501 38.796 49.6541 38.796C50.3021 38.796 50.7641 38.556 51.0401 38.076C51.3281 37.584 51.4961 36.954 51.5441 36.186L51.6521 34.026C51.4961 33.99 51.3101 33.954 51.0941 33.918C50.8781 33.882 50.6501 33.864 50.4101 33.864C49.8341 33.864 49.3661 34.002 49.0061 34.278C48.6581 34.554 48.4061 34.908 48.2501 35.34C48.0941 35.772 48.0161 36.228 48.0161 36.708Z",
    fill: "#244469"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10V1M76 20L82 14M23 20L17 14",
    stroke: "#FFD600",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupEmailIcon);
export default __webpack_public_path__ + "static/media/popup_email_icon.079db651a84da54be76d20348508f6d1.svg";
export { ForwardRef as ReactComponent };